import React from 'react'
import '../../App.css';

import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Typography, Paper, useMediaQuery, useTheme, Box, Card, CardContent } from '@mui/material';

function RaspTable({data}) {

    function getNextDays(count = 7, startDate = new Date()) {
        const result = [];
        const weekdayFormatter = new Intl.DateTimeFormat('ru-RU', { weekday: 'long' });
        const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });

        for (let i = 0; i < count; i++) {
            const d = new Date(startDate);
            d.setDate(d.getDate() + i);

            result.push({
            date: dateFormatter.format(d),     // например: "20.11.2025"
            weekday: weekdayFormatter.format(d), // например: "четверг"
            });
        }

        return result;
        }


    const days = getNextDays();    
    const colLabels = ["Уч.", "№ каб", "Врач"].concat(days.map(item => item.date + "\n" + item.weekday))
    const uch = [...new Set(data.map(item => item["uch"].trim()).join(" ").split(" "))].sort((a,b) => a - b) 
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); 
    
    if (isMobile) {
        // мобильный вид — карточки
        return (
        <div className="App"> 
            <Box display="flex" flexDirection="column" gap={1}>
                {uch.map((uchNumber, keyRow) => (
                <Card key={keyRow} variant="outlined">
                    <CardContent>
                        {[...new Set(data.filter(item => item["uch"].includes(" " + uchNumber + " ")).map(item => item["fio"]))].map((fio, keyFio) => 
                        <Table>
                            <TableBody>
                                <TableRow key = {keyFio}>
                                    <TableCell > {colLabels[0]} </TableCell>
                                    <TableCell key={uchNumber + keyRow}> {uchNumber} </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell > {colLabels[1]} </TableCell>
                                    <TableCell key={"100" + keyRow}> {data.filter(item => item["fio"].includes(fio))[0]["kab"]} </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell > {colLabels[2]} </TableCell>
                                    <TableCell key={fio + keyRow}> {fio} </TableCell> 
                                </TableRow>

                                    {
                                        days.map((day, dayKey) => 
                                            <TableRow>
                                                <TableCell>{day["date"]}</TableCell>
                                                <TableCell key={dayKey + keyRow}> {data.filter(item => item["fio"] === fio && item["uch"].includes(" " + uchNumber + " ") && item["report_date"].split("-").reverse().join(".") === day["date"]).map(item => item["schedule"])} </TableCell>
                                            </TableRow>
                                        )
                                    }

                                
                            </TableBody>
                        </Table>
                        )}
                    </CardContent>
                </Card>
                ))}
            </Box>
        </div>
        );
    }


    return (
    <div className="App">    
        <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
            <Table aria-label="table" sx={{ minWidth: 940 }}>
                <TableHead>
                <TableRow>
                    {colLabels.length && colLabels?.map((item) => 
                        <TableCell align="right" key={item}>
                            <Typography fontWeight={"bold"}>{item}</Typography> 
                        </TableCell>)}
                </TableRow>
                </TableHead>
                <TableBody>
                    {uch && uch?.map((uchNumber, keyRow) => 
                    {
                        return [...new Set(data.filter(item => item["uch"].includes(" " + uchNumber + " ")).map(item => item["fio"]))].map((fio, keyFio) => 
                             
                            <TableRow key = {keyFio}>
                                <TableCell key={uchNumber + keyRow}> {uchNumber} </TableCell>
                                <TableCell key={"100" + keyRow}> {data.filter(item => item["fio"].includes(fio))[0]["kab"]} </TableCell>
                                <TableCell key={fio + keyRow}> {fio} </TableCell> 
                                {
                                    days.map((day, dayKey) => 
                                        <TableCell key={dayKey + keyRow}> {data.filter(item => item["fio"] === fio && item["uch"].includes(" " + uchNumber + " ") && item["report_date"].split("-").reverse().join(".") === day["date"]).map(item => item["schedule"])} </TableCell>
                                    )
                                }

                            </TableRow>
                        )
                    }
                        
                    )}
                </TableBody>
            </Table>
        </TableContainer>
      
    </div>
  );

}

export default RaspTable;